import React, { useEffect, useState } from "react";
import { Form, Input, Switch, message, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import { editServer } from "../../../API/server";

const EditEmailServer = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const server = location.state?.server;

  useEffect(() => {
    if (server) {
      form.setFieldsValue({
        host: server.host,
        port: server.port,
        username: server.username,
        password: server.password,
        use_ssl: server.use_ssl,
        use_tls: server.use_tls,
      });
    }
  }, [server, form]);

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const response = await editServer(server?.id, values);
      if (Math.floor(response?.status / 100) === 2) {
        message.success("Server configuration saved successfully!");
        form.resetFields();
        navigate("/email-servers");
      } else {
        message.error(JSON.stringify(response?.data?.errors));
      }
    } catch (error) {
      message.error("Failed to create server");
    } finally {
      setLoading(false);
    }

    setLoading(false);
  };

  const handleResetForm = () => {
    form.resetFields();
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="page">
      <div className="back-btn">
        <Button icon={<ArrowLeftOutlined />} onClick={handleBack}>
          Back
        </Button>
      </div>
      <div className="add-email">
        <div className="container">
          <div className="top-container">
            <div className="top-content">
              <div className="title">Server Configuration</div>
              <div className="sub-title">
                Configure your outgoing SMTP settings and authentication
                credentials
              </div>
            </div>
            <div className="border"></div>
            <div className="second-container">
              <Form form={form} layout="vertical" onFinish={onFinish}>
                <div className="item-wrapper">
                  <div className="item">
                    <Form.Item
                      label="Host"
                      name="host"
                      rules={[{ required: true, message: "Please add host!" }]}
                    >
                      <Input placeholder="smtp.example.com" />
                    </Form.Item>
                  </div>

                  <div className="item">
                    <Form.Item
                      label="Port Number"
                      name="port"
                      rules={[
                        { required: true, message: "Please add port number!" },
                      ]}
                    >
                      <Input placeholder="Port Number" />
                    </Form.Item>
                  </div>
                </div>

                <div className="item-wrapper">
                  <div className="item">
                    <Form.Item
                      label="Username"
                      name="username"
                      rules={[
                        { required: true, message: "Please add username!" },
                      ]}
                    >
                      <Input placeholder="Username" />
                    </Form.Item>
                  </div>

                  <div className="item">
                    <Form.Item
                      label="Password"
                      name="password"
                      rules={[
                        { required: true, message: "Please add password!" },
                      ]}
                    >
                      <Input.Password placeholder="Password" />
                    </Form.Item>
                  </div>
                </div>

                <div className="second-border"></div>
                <div className="security">
                  <div className="security-title">Security Protocols</div>
                  <div className="security-options">
                    <div className="security-item">
                      <div className="security-header">
                        <Form.Item name="use_ssl" valuePropName="checked">
                          <Switch />
                        </Form.Item>
                        <div className="toggle-title">Use SSL</div>
                      </div>
                      <div className="security-desc">
                        Ensures all data transmitted is encrypted. Highly
                        recommended for production environments.
                      </div>
                    </div>

                    <div className="security-item">
                      <div className="security-header">
                        <Form.Item name="use_tls" valuePropName="checked">
                          <Switch />
                        </Form.Item>
                        <div className="toggle-title">Use TLS</div>
                      </div>
                      <div className="security-desc">
                        Ensures all data transmitted is encrypted. Highly
                        recommended for production environments.
                      </div>
                    </div>
                  </div>
                  <div className="second-border"></div>
                </div>

                <Form.Item>
                  <div className="form-footer">
                    <button
                      type="button"
                      className="cancel-btn"
                      onClick={handleResetForm}
                    >
                      Cancel
                    </button>

                    <Button
                      type="primary"
                      className="save-btn"
                      loading={loading}
                      htmlType="submit"
                    >
                      Save & Connect
                    </Button>
                  </div>
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditEmailServer;
